import { Selector, State } from '@ngxs/store';
import { FunctionalityStateModel } from './functionality.model';

@State<FunctionalityStateModel>({
  name: 'functionality'
})
export class FunctionalityState {
  @Selector()
  static functionality(state: FunctionalityStateModel) {
    return state;
  }

  constructor() {}
}
